import React from 'react'

function AppointmentItem({appointment,bColor="bg-light-info"}) {
  return (
    <div className={bColor+" p-4 mt-4 rounded"}>   
    <div className="row">
        <div className="col-3">
              <div className="d-flex flex-column align-items-start">
                  <span>2024-04-19</span>
                  <span className="text-muted">15:30 - 15:45</span>
                  <span>Eyeconx Confirmed</span>
              </div>

        </div>
        <div className="col-6">
            <div className="d-flex flex-column">
                <span>Type : SMtsdf </span>
                <span>Reason : This is reason of the appointment.</span>
            </div>
        </div>
        <div className="col-3">
            <div className="d-flex flex-column">
              <span> Doctor: Fiona Soong</span>
              <div className="d-flex">
                  <span className="me-2">Email :</span>
                  <span className="me-2">SMS :</span>
                  <span className="me-2">Call :</span>
              </div>
            </div>
           
        </div>
    </div>
    <table className="table table-sm table-striped border m-1 mt-3">
        <thead>
            <tr>
                <th></th>
                <th>Has</th>
                <th>Status</th>
                <th>Sent Type</th>
                <th>Date</th>
               
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className='ps-3'>Prebooked</td>
                <td> <i className="bi bi-check-square-fill"></i> </td>
                <td> Sent </td>
                <td> Email </td>
                <td> 2024-02-25 </td>
            </tr>
            <tr>
                <td className='ps-3'>First</td>
                <td> <i className="bi bi-check-square-fill"></i> </td>
                <td> Sent </td>
                <td> Email </td>
                <td> 2024-02-25 </td>
            </tr>
            <tr>
                <td className='ps-3'>Second</td>
                <td> <i className="bi bi-check-square-fill"></i> </td>
                <td> Sent </td>
                <td> Email </td>
                <td> 2024-02-25 </td>
            </tr>
            <tr>
                <td className='ps-3'>Last</td>
                <td> <i className="bi bi-check-square-fill"></i> </td>
                <td> Sent </td>
                <td> Email </td>
                <td> 2024-02-25 </td>
            </tr>
            <tr>
                <td className='ps-3'>Same Day</td>
                <td> <i className="bi bi-check-square-fill"></i> </td>
                <td> Sent </td>
                <td> Email </td>
                <td> 2024-02-25 </td>
            </tr>
        </tbody>
    </table>
    </div>
  )
}

export default AppointmentItem